requestIdleCallback(
  function () {
    const SURVEY_CAMPAIGN_ID = 15559;
    const SURVEY_EVENT_COUNT_KEY = 'survey_poll_event_count';
    const SURVEY_ANSWERS_KEY = 'survey_answers';
    const SURVEY_QUESTIONS = [
      "What's your biggest skin struggle?",
      'What brings you here today?',
      'When you see "clinically proven" on a product, what comes to your mind?',
      'What would make you trust a "clinically proven" claim more?',
    ];

    function getStoredAnswers() {
      try {
        const raw = localStorage.getItem(SURVEY_ANSWERS_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (err) {
        console.error('[SURVEY] Error reading answers:', err);
        return [];
      }
    }

    function setStoredAnswers(answers) {
      try {
        localStorage.setItem(SURVEY_ANSWERS_KEY, JSON.stringify(answers));
      } catch (err) {
        console.error('[SURVEY] Error storing answers:', err);
      }
    }

    function upsertAnswer(question, answer) {
      const answers = getStoredAnswers();
      const existingIndex = answers.findIndex((item) => item.question === question);
      if (existingIndex >= 0) {
        if (answers[existingIndex].answer !== answer) {
          answers[existingIndex] = { question, answer };
        }
      } else {
        answers.push({ question, answer });
      }
      setStoredAnswers(answers);
    }

    function incrementEventCount() {
      const count = Number(localStorage.getItem(SURVEY_EVENT_COUNT_KEY) || 0);
      const next = count + 1;
      localStorage.setItem(SURVEY_EVENT_COUNT_KEY, String(next));
      return count;
    }

    function clearSurveyStorage() {
      localStorage.removeItem(SURVEY_EVENT_COUNT_KEY);
      localStorage.removeItem(SURVEY_ANSWERS_KEY);
      localStorage.removeItem('survey_email');
      localStorage.removeItem('survey_phone');
    }

    document.addEventListener('alia:pollAnswered', (event) => {
      const detail = event && event.detail ? event.detail : null;
      if (!detail || detail.campaignID !== SURVEY_CAMPAIGN_ID) {
        return;
      }

      const previousCount = incrementEventCount();
      if (previousCount === 0) {
        return;
      }

      const answers = Array.isArray(detail.answers) ? detail.answers : [];
      if (!answers[0]) {
        return;
      }

      const answerText = answers[0].answerText;
      const questionIndex = previousCount - 1;
      if (questionIndex < 0 || questionIndex >= SURVEY_QUESTIONS.length) {
        return;
      }

      const questionText = SURVEY_QUESTIONS[questionIndex];
      if (questionText && answerText) {
        upsertAnswer(questionText, answerText);
      }
    });

    document.addEventListener('alia:signup', (e) => {
      try {
        if (e.detail && e.detail.email) {
          localStorage.setItem('survey_email', e.detail.email);
          console.log('[SURVEY] Stored email in localStorage');
        }
        if (e.detail && e.detail.phone) {
          localStorage.setItem('survey_phone', e.detail.phone);
          console.log('[SURVEY] Stored phone in localStorage');
        }
      } catch (err) {
        console.error('[SURVEY] Error storing data:', err);
      }

      const stored_answers = getStoredAnswers();
      const stored_email = localStorage.getItem('survey_email');
      const stored_phone = localStorage.getItem('survey_phone');

      if (stored_answers.length < 4 || !stored_email || !stored_phone) {
        return;
      }

      var cl_identify_survey = setInterval(function () {
        if (((window.CLabsgbVar || {}).generalProps || {}).uid) {
          var user_traits = {
            phone: { t: 'string', v: stored_phone },
            email: { t: 'string', v: stored_email },
          };

          var user_props = {
            customProperties: {
              user_traits: { t: 'Object', v: user_traits },
              identify_by_email: { t: 'string', v: stored_email, ib: true },
              external_ids: {
                t: 'Object',
                v: {
                  identify_by_phone: { t: 'string', v: stored_phone },
                },
              },
            },
          };

          var custom_properties = {};
          stored_answers.forEach(function (item) {
            var key = item.question
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '_')
              .replace(/^_|_$/g, '');
            custom_properties[key] = {
              t: 'string',
              v: item.answer,
            };
          });

          var properties = {};
          properties.customProperties = custom_properties;

          _cl.identify(user_props);
          _cl.trackClick('alia_survey_completed', properties);
          clearInterval(cl_identify_survey);
          clearSurveyStorage();
        }
      }, 1000);
    });
  },
  { timeout: 3000 }
); /* end requestIdleCallback */
